"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.create = exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _redux = require("redux");

var _reduxThunk = _interopRequireDefault(require("redux-thunk"));

var _reduxLoggerHelper = _interopRequireWildcard(require("./helpers/redux-logger-helper"));

var _reduxBatchedActions = require("redux-batched-actions");

var _reduxBatchEnhancer = require("redux-batch-enhancer");

var _reducerRegistry = require("./reducer-registry");

var _analyticsMiddleware = require("./analytics/middleware/analytics-middleware");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var StaticStore = function StaticStore() {
  (0, _classCallCheck2["default"])(this, StaticStore);
};

StaticStore.store = void 0;

StaticStore.create = function (config, reducers, middlewareArray, preLoadedData) {
  var legacyReducers = {}; // register all (legacy) reducers, we should be using ReducerRegistry.register().

  for (var key in reducers) {
    var _reducer = reducers[key];

    if (typeof _reducer !== 'function') {
      var obj = {
        error: 'reducer should be a function'
      };
      throw obj;
    }

    _reducer(legacyReducers);
  } // Preserve initial state for not-yet-loaded reducers


  var combine = function combine(reducers) {
    return (0, _redux.combineReducers)(_objectSpread({}, legacyReducers, {}, reducers));
  };

  var middlewares = [_reduxThunk["default"], _reduxBatchEnhancer.batchMiddleware, _analyticsMiddleware.analyticsMiddleware];

  if (middlewareArray) {
    middlewares = middlewares.concat(middlewareArray);
  } // If we are in dev, push the logger


  if ((0, _reduxLoggerHelper.enableLogger)(config)) {
    middlewares.push(_reduxLoggerHelper["default"]);
  }

  var reducer = combine((0, _reducerRegistry.getReducers)());
  var newStore;

  if (!process.env.isProd && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__) {
    // const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
    // newStore = createStore(combinedReducers, preloadedState, composeEnhancers(
    //   applyMiddleware(...middlewares)
    // ))

    /*
     * Important note!
     * We will need to enable batching for injected reducers if that POC and this POC
     * Ever get merged
     * */
    newStore = (0, _redux.createStore)((0, _reduxBatchedActions.enableBatching)(reducer), preLoadedData, (0, _redux.compose)(_redux.applyMiddleware.apply(void 0, (0, _toConsumableArray2["default"])(middlewares)), window.__REDUX_DEVTOOLS_EXTENSION__(), _reduxBatchEnhancer.batchStoreEnhancer));
  } else {
    newStore = (0, _redux.createStore)((0, _reduxBatchedActions.enableBatching)(reducer), preLoadedData, (0, _redux.compose)(_redux.applyMiddleware.apply(void 0, (0, _toConsumableArray2["default"])(middlewares)), _reduxBatchEnhancer.batchStoreEnhancer));
  }

  StaticStore.store = newStore; // Replace the store's reducer whenever a new reducer is registered.

  (0, _reducerRegistry.setChangeListener)(function (reducers) {
    StaticStore.store.replaceReducer(combine(reducers));
  });
  return newStore;
};

var getStore = function getStore() {
  return StaticStore.store;
};

var create = function create(config, reducers, middlewares, preLoadedData) {
  return StaticStore.create(config, reducers, middlewares, preLoadedData);
};

exports.create = create;
var _default = getStore;
exports["default"] = _default;